import React, {useEffect} from 'react'
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import { htmlDecode } from '../../_global/js/Utils.js';
import DOMPurify from 'dompurify';

const OptionTooltip = () => {
  
  const { showOptionTooltipModal, tooltipContent, setShowOptionTooltipModal } = useStore(state =>({
    showOptionTooltipModal: state.showOptionTooltipModal,
    tooltipContent: state.tooltipContent,
    setShowOptionTooltipModal: state.setShowOptionTooltipModal,
  }), shallow);

  const content = htmlDecode(tooltipContent);
  
  const showingTTModal = showOptionTooltipModal ? true : false;

  const closeOptionTooltip = () => {
    setShowOptionTooltipModal(false);
  }

  const doNotCloseModal = e => {
    // e.preventDefault();
    e.stopPropagation();
    // e.stopImmediatePropagation();
    return false;
  }

  useEffect(() => {
    const close = (e) => {
      if(e.key === 'Escape'){
        closeOptionTooltip()
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  })

  return (
    <div onClick={closeOptionTooltip} className={`option-tooltip_overlay email_modal_container ${showingTTModal ? '' : 'hide'}`}>
      <div className="option-tooltip-outer">
        <div className="option-tooltip_wrapper" onClick={doNotCloseModal}>
            <div className='option-tooltip_content' dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content, {ADD_ATTR:['target']})}} />
            <button className="option-tooltip_close" onClick={closeOptionTooltip}>Close x</button>
        </div>
      </div>
    </div>
  )
}

OptionTooltip.propTypes = {}

export default OptionTooltip;